export default {
  lastAkrualUpdateTime: null,
}